import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StateStatus } from '../core';
import { getProductCategories } from '../new/category';

const useProductCategories = ({ providerId } = {}) => {
  const dispatch = useDispatch();

  const { data, status, version, entity, request } = useSelector(state => state.categories.products);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request.providerId !== providerId)) {
      dispatch(getProductCategories(providerId));
    }
  }, [data, dispatch, providerId, request, status]);

  return { data: data || [], status, version, entity };
};

export default useProductCategories;
